import 'graphiql/graphiql.min.css';
import { useEffect, useState } from 'react';

import { GraphiQL } from 'graphiql';
import type { Fetcher } from '@graphiql/toolkit';

import { useAppSelector } from 'app/store';
import { selectUserInfo } from 'app/store/user';
import PreloaderIcon, { RyeLogoSizeClass } from 'components/Preloader';

import config from 'config/constants';
import { getGraphiQLHeaders } from 'app/utils';

import './style.scss';

const DEFAULT_QUERY = `
query {
  productsByDomainV2(
    input: {domain: "alo-yoga.myshopify.com"}
    pagination: {offset: 0, limit: 10}
  ) {
    id
    title
  }
}
`.trim();

const Page = () => {
  const { apiKey = '' } = useAppSelector(selectUserInfo) || {};
  const [headers, setHeaders] = useState('');

  useEffect(() => {
    if (apiKey) {
      getGraphiQLHeaders(apiKey).then((headersString) => setHeaders(headersString));
    }
  }, [apiKey]);

  const fetcher: Fetcher = async (graphQLParams, options) => {
    const data = await fetch(config.external.gql, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: JSON.stringify(graphQLParams),
    });
    return data.json().catch(() => data.text());
  };

  // Wrap in a flex column so the playground fills whatever vertical space
  // Layout (fitted variant) hands us. min-h-0 lets the GraphiQL container
  // shrink below the natural editor min-height when the viewport is short.
  return (
    <div className="flex h-full min-h-0 w-full flex-1 flex-col">
      {apiKey ? (
        <GraphiQL
          defaultQuery={DEFAULT_QUERY}
          defaultEditorToolsVisibility="headers"
          disableTabs
          fetcher={fetcher}
          headers={headers}
          showPersistHeadersSettings={false}
          onEditHeaders={setHeaders}
        />
      ) : (
        <div className="graphiql-container is-loading">
          <PreloaderIcon size={RyeLogoSizeClass.small} />
        </div>
      )}
    </div>
  );
};

export default Page;
